import * as R from 'ramda'
import { Page } from '../actions/'

const DEFAULT_STATE = {
  home: [],
  page: [],
}

const reducer = (state = DEFAULT_STATE, action) =>
  R.cond([
    [
      R.equals(Page.TYPE.receive_home),
      () => R.merge(state, { home: action.payload }),
    ],
    [
      R.equals(Page.TYPE.receive_page),
      () => R.merge(state, { page: action.payload }),
    ],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
